<template>
  <v-container class="pa-0">
    <v-row>
      <v-col :cols="selected === undefined ? '12' : '6'">
        <v-list>
          <v-list-item-group v-model="selected">
            <v-list-item
              v-for="user in usersData"
              :key="user.key"
            >
              <v-list-item-title>{{ user.login }}</v-list-item-title>
              <v-list-item-action>
                <v-icon v-if="user.id_usr == 0">mdi-account-plus</v-icon>
                <v-icon v-else>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="selected !== undefined"
        cols="6"
      >
        <v-window show-arrows>
          <template v-slot:prev="{ on, attrs }">
            <v-btn
              icon
              color="success"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <template v-slot:next="{ on, attrs }">
            <v-btn
              icon
              color="warning"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-lock</v-icon>
            </v-btn>
          </template>
          <v-tabs
            v-model="activeTab"
            fixed-tabs
          >
            <v-tab>
              <v-icon left>mdi-account</v-icon>
              {{ $t("profile.tabs.general") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-lock</v-icon>
              {{ $t("profile.tabs.secure") }}
            </v-tab>
            <v-tab-item class="mt-4">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="usersData[selected].login"
                      :label="$t('profile.sections.user.login')"
                      append-icon="email"
                      type="email"
                      :rules="[rules.required, rules.regex]"
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row v-if="usersData[selected].id_usr == 0">
                  <v-col cols="12">
                    <v-text-field
                      v-model="usersData[selected].password"
                      :append-icon="show ? 'visibility' : 'visibility_off'"
                      :rules="[rules.required, rules.min]"
                      :type="show ? 'text' : 'password'"
                      :label="$t('profile.sections.user.password')"
                      :hint="this.$t('field.min-8')"
                      counter
                      dense
                      @click:append="show = !show"
                    />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12">
                    <v-text-field
                      v-model="usersData[selected].password"
                      :append-icon="show ? 'visibility' : 'visibility_off'"
                      :type="show ? 'text' : 'password'"
                      :label="$t('profile.sections.user.password-edit')"
                      :hint="this.$t('field.min-8')"
                      counter
                      dense
                      @click:append="show = !show"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="usersData[selected].name"
                      :rules="[rules.required]"
                      :label="$t('profile.sections.common.name')"
                      dense
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="usersData[selected].firstname"
                      :rules="[rules.required]"
                      :label="$t('profile.sections.user.firstname')"
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="usersData[selected].phone"
                      :rules="[]"
                      :label="$t('profile.sections.user.phone')"
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="usersData[selected].access"
                      :items="accessesData"
                      :label="$t('profile.sections.user.access')"
                      dense
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container>
                <v-row>
                  <v-col>
                    <input-button-dialog
                      :btn-label="$t('dialog.browse')"
                      :txt-label="$t('mediacenter.directory')"
                      :value="dirDisplay"
                      @cancel-pushed="resetDir"
                    >
                      <dir-explorer
                        :root-dir="dirPath"
                        :share-access="false"
                        :current-item="[usersData[selected].dir]"
                        :no-context="true"
                        @item-selected="setDir"
                      />
                    </input-button-dialog>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="search"
                      :label="$t('schedule.player-search')"
                      single-line
                      hide-details
                      append-icon="mdi-magnify"
                      clearable
                      dense
                    />
                    <v-treeview
                      v-model="usersData[selected].players"
                      :items="players"
                      :search="search"
                      selectable
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-window>
        <v-row v-if="usersData[selected].id_usr == 0">
          <v-col cols="12">
            <v-btn
              color="success"
              :disabled="
                usersData[selected].login.length < 6 || usersData[selected].password.length < 8 || disableButton
              "
              @click="createUser()"
            >
              <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.create") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="6">
            <v-btn
              color="primary"
              :disabled="usersData[selected].login.length < 6 || disableButton"
              @click="checkBeforeUpdate()"
            >
              <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <button-dialog-delete
              :text="$t('popup.user')"
              :is-button-disabled="usersData.length <= 2 || disableButton"
              @ok-pushed="disableUser(usersData[selected].id_usr)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";
import inputButtonDialog from "../Common/InputButtonDialog";
import dirExplorer from "../Common/DirExplorer";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector";
import { ProfileAccessConnector } from "../Database/ProfileAccessConnector.js";
import { ProfileUserConnector } from "../Database/ProfileUserConnector.js";

export default {
  components: {
    buttonDialogDelete,
    inputButtonDialog,
    dirExplorer,
  },
  data() {
    return {
      accessConnector: new ProfileAccessConnector(this.$store.state.user),
      playerConnector: new PlayerConnector(this.$store.state.user),
      userConnector: new ProfileUserConnector(this.$store.state.user),
      selected: undefined,
      usersData: [],
      accessesData: [],
      players: [],
      disableButton: false,
      dirPath: [],
      dirSelection: [],
      search: "",
      show: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
        regex: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("profile.sections.user.mail"),
      },
      activeTab: null,
    };
  },
  computed: {
    dirDisplay() {
      const splitPath = "/mediacenter/" + this.$store.state.user.socId + "/";
      const dirSplit = this.usersData[this.selected].dir.split(splitPath);

      if (dirSplit.length > 1) {
        return dirSplit[1];
      } else {
        return "";
      }
    },
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getListAccess();
      this.getUsersData();
      this.getAllPlayers();

      // Set root path for user directory limit
      this.dirPath = this.$store.state.config.dirs.mediacenter + this.$store.state.user.socId;

      // If dir limited for user we use this root path
      if (this.$store.state.user.dir != "") {
        this.dirPath = this.$store.state.user.dir;
      }

      this.dirSelection = [this.dirPath];
    }
  },
  methods: {
    getAllPlayers() {
      this.playerConnector
        .getAllPlayersIdName()
        .then((players) => {
          this.players = players;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getListAccess() {
      this.accessConnector.getListAccess().then((accesses) => {
        // TODO: format in db server
        this.accessesData = accesses.map((data) => {
          return {
            value: data.id_right,
            text: data.name,
          };
        });
      });
    },
    getUsersData() {
      this.userConnector.getUsersData().then((users) => {
        // TODO: format in db server
        this.usersData = users.map((data) => {
          let pAccess = [];

          if (data.players !== null) {
            pAccess = data.players.split("|").map((player) => {
              return parseInt(player);
            });
          }

          return {
            id_usr: data.id_usr,
            login: data.login,
            password: "",
            name: data.lastname,
            firstname: data.firstname,
            phone: data.phone,
            access: data.right_id,
            dir: data.dir,
            players: pAccess,
          };
        });

        this.usersData.unshift({
          id_usr: 0,
          login: this.$t("profile.sections.user.new"),
          password: "",
          name: "",
          firstname: "",
          phone: "",
          dir: "",
          players: [],
          access: 0,
        });
      });
    },
    createUser() {
      if (this.usersData[this.selected].login.length >= 6 && this.usersData[this.selected].password.length >= 8) {
        this.disableButton = true;

        this.userConnector
          .insertUserData(this.usersData[this.selected])
          .then(() => {
            this.getUsersData();
            this.usersData[this.selected].password = "";

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.create-user"),
              colorBg: "green",
            });
          })
          .catch((response) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.create-user"),
              colorBg: "red",
            });
            console.error(response);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    checkBeforeUpdate() {
      if (this.usersData[this.selected].password.length == 0) {
        this.updateUserDataWithoutPassword(this.usersData[this.selected].id_usr);
      } else if (
        this.usersData[this.selected].password.length < 8 &&
        this.usersData[this.selected].password.length >= 1
      ) {
        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("error.incomplete-password"),
          colorBg: "orange",
        });
      } else {
        this.updateUserData(this.usersData[this.selected].id_usr);
      }
    },
    updateUserData(uid) {
      if (this.usersData[this.selected].login.length >= 6 && this.usersData[this.selected].password.length >= 8) {
        this.disableButton = true;

        this.userConnector
          .updateUserData(this.usersData[this.selected], uid)
          .then(() => {
            this.usersData[this.selected].password = "";

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.update-user"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    updateUserDataWithoutPassword(uid) {
      if (this.usersData[this.selected].login.length >= 6) {
        this.disableButton = true;

        this.userConnector
          .updateUserDataWithoutPassword(this.usersData[this.selected], uid)
          .then(() => {
            this.usersData[this.selected].password = "";

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.update-user"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    disableUser(uid) {
      if (uid > 0) {
        this.userConnector
          .disableUserData(uid)
          .then(() => {
            this.usersData.splice(this.selected, 1);
            this.selected = undefined;

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.delete-user"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.delete"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    setDir(dir) {
      if (dir.length > 0) {
        this.usersData[this.selected].dir = dir[0];
      } else {
        this.resetDir();
      }
    },
    resetDir() {
      this.usersData[this.selected].dir = "";
    },
  },
};
</script>

<style></style>
